export const clearUserSession = () => {
  localStorage.removeItem("MFAAuthDetails");
  sessionStorage.clear();
};
